var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "700px", "overflow-y": "auto" } }, [
    _c(
      "div",
      { staticClass: "print", attrs: { id: "printBagNo" } },
      _vm._l(_vm.printData, function (item, index) {
        return _c("div", { key: index, staticClass: "print-page" }, [
          _c("img", {
            staticStyle: { height: "100px", margin: "10px 0" },
            attrs: { src: require("@/assets/img-logo.png"), alt: "" },
          }),
          _c("div", { staticClass: "text-con" }, [
            _vm._v("集货码-Código de Pré-Carregamento"),
          ]),
          _c("div", { staticClass: "bag_no" }, [
            _c("div", { attrs: { id: "printBagNoSvg" + index } }),
          ]),
          _c(
            "div",
            { staticClass: "text-con", staticStyle: { "font-size": "38px" } },
            [_vm._v(_vm._s(item.code))]
          ),
        ])
      }),
      0
    ),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { id: "img-logo" } },
      [
        _c("img", {
          staticStyle: { height: "100px", "margin-bottom": "40px" },
          attrs: { src: require("@/assets/img-logo.png"), alt: "" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }